"use client";
import {useEffect} from "react";
import {useCookieCampusId} from "./contexts/CampusCookieContext";
import {useUserInfo} from "@/app/_components/contexts/userInfoContext";
import getUserData from "@/app/_components/EventTracker/getUserData";
import mixpanel from "mixpanel-browser";
import {
	MIXPANEL_SUPER_PROPERTIES,
	initMixpanel,
} from "../../lib/mixpanelClient";

/**
 * Utility component which attaches some variables to the window object for
 * analytics tagging and starts Mixpanel for event tracking.
 */
const AnalyticsVariablesSetter = () => {
	const {userInfo, isLoading} = useUserInfo();
	const campusId = useCookieCampusId();

	useEffect(() => {
		if (isLoading) {
			return;
		}

		const analyticsData = getUserData(userInfo, campusId);
		window.analytics = analyticsData;

		// Add to `window.dataLayer` which is used directly by Google Tag Manager
		window.dataLayer?.push(window.analytics);

		/* This effect runs every time `userInfo` changes (login & logout) and
		 * when the `campusId` changes.
		 *
		 * initMixpanel, at time of writing, skips double initializing to avoid
		 * problems.
		 */
		const isMixpanelInitialized = initMixpanel();
		if (!isMixpanelInitialized) {
			return;
		}

		if (userInfo) {
			mixpanel.identify(userInfo.platform_user_id);
			mixpanel.people.set(analyticsData);
		} else {
			// Reset is only called during logout:
			// https://docs.mixpanel.com/docs/tracking-methods/sdks/javascript#call-reset-at-logout
			mixpanel.reset();
			mixpanel.register(MIXPANEL_SUPER_PROPERTIES);
		}
	}, [userInfo, campusId, isLoading]);
	return null;
};

export default AnalyticsVariablesSetter;
